module.exports = __webpack_public_path__ + "img/title-3.53836c56.png";